import React, { Fragment, useState, useCallback, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Row, Col, Card, CardBody, } from 'reactstrap';
import { tableColumns } from './TransactionData';
// import axios from 'axios';
import { ServerPath } from '../../Constant';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';
import { _axios } from '../../utils/axios';
import { Btn } from '../../AbstractElements';

const tableStyles = `
  .rdt_TableCell {
    padding: 4px 2px !important;
  }
  .rdt_TableHead {
    padding: 4px 2px !important;
  }
  .rdt_TableCol {
    padding: 4px 2px !important;
  }
  .rdt_TableCell[data-column-id="payment_status"] {
    position: sticky !important;
    right: 0;
    background-color: white !important;
     background-color: inherit !important;
    z-index: 1;
  }
  .rdt_TableHeadRow [data-column-id="payment_status"] {
    position: sticky !important;
    right: 0;
    background-color: white !important;
    z-index: 1;
  }
  .data-tables {
    overflow-x: auto;
    .badge-success {
      background-color: #E8FFF3 !important;
      color: #0BAF62 !important;
      border-radius: 16px !important;
      padding: 4px 12px !important;
      font-weight: 500 !important;
    }
    .badge-warning {
      background-color: #FFF8DD !important;
      color: #E8B600 !important;
      border-radius: 16px !important;
      padding: 4px 12px !important;
      font-weight: 500 !important;
    }
  }
`;


const TransactionTable = ({ searchValue, selectedFilter, dateRange }) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelete, setToggleDelete] = useState(false);
    const [data, setData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    const applyFiltersAndSearch = useCallback((searchValue, filterValue, dateValue) => {
        let filteredData = [...originalData];

        if (searchValue && searchValue.trim()) {
            const searchTerm = searchValue.toLowerCase();
            filteredData = filteredData.filter(item => {
                return (
                    String(item.transaction_id || '').toLowerCase().includes(searchTerm) ||
                    String(item.payee || '').toLowerCase().includes(searchTerm) ||
                    String(item.host_name || '').toLowerCase().includes(searchTerm)
                );
            });
        }

        if (filterValue && filterValue !== 'all') {
            filteredData = filteredData.filter(item => {
                // Extract the actual status value from the payment_status span element
                const paymentStatus = typeof item.payment_status === 'object' 
                    ? item.payment_status.props.children 
                    : item.payment_status;
                return paymentStatus === filterValue;
            });
        }


        if (dateValue?.startDate && dateValue?.endDate) {
            filteredData = filteredData.filter(item => {
                if (!item.date_time) return false;
                const itemDate = new Date(item.date_time.split(' ')[0].split('/').reverse().join('-'));
                const startDate = new Date(dateValue.startDate);
                const endDate = new Date(dateValue.endDate);

                // Reset time parts for accurate date comparison
                itemDate.setHours(0, 0, 0, 0);
                startDate.setHours(0, 0, 0, 0);
                endDate.setHours(23, 59, 59, 999);

                return itemDate >= startDate && itemDate <= endDate;
            });
        }

        setData(filteredData);
    }, [originalData]);

    // Apply filters when props change
    useEffect(() => {
        applyFiltersAndSearch(searchValue, selectedFilter, dateRange);
    }, [searchValue, selectedFilter, dateRange, applyFiltersAndSearch]);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';

        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return 'Invalid Date';

            // Get individual components
            const day = date.getDate();
            const month = date.getMonth() + 1; // getMonth() returns 0-11
            const year = date.getFullYear();

            // Get time in 12-hour format
            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';

            // Convert hours to 12-hour format
            hours = hours % 12;
            hours = hours ? hours : 12; // Convert 0 to 12

            // Format the date string
            return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;

        } catch (error) {
            console.error('Error formatting date:', error);
            return 'Invalid Date';
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await _axios.get(`${ServerPath}/transaction-history/admin`);
                console.log("Transaction Data:", response);

                if (response.data.success === 1 && Array.isArray(response.data.data)) {
                    const transactionData = response.data.data.map(transaction => {
                        // Format date inside the map function
                        const formattedDate = formatDate(transaction.transaction_date);
                        console.log("Formatted date for transaction:", formattedDate);

                        return {
                            ...transaction,
                            payee_name: transaction?.payee_name || 'N/A',
                            host_name: transaction.host_name,
                            net_amount: `${parseFloat(transaction.net_amount) - parseFloat(transaction.convenience_fee)}`,
                            amount: `${parseFloat(transaction.amount)}`,
                            convenience_fee: `${parseFloat(transaction.convenience_fee)}`,
                            date_time: formattedDate,
                            transaction_id: transaction.transaction_id,
                            razorpay_order_id: transaction.razorpay_order_id,
                            payment_status: <span
                                className={`badge rounded-pill ${transaction?.payment_status === 'SUCCESS' ? 'badge-success' :
                                    transaction?.payment_status === 'PENDING' ? 'badge-warning' : 'badge-danger'}`}
                            >
                                {transaction?.payment_status || 'N/A'}
                            </span>,
                            action: (
                                <div className="action d-flex justify-content-center">
                                    <div className="delete">
                                        <Button
                                            className="btn-square btn btn-danger mx-2"
                                            onClick={(e) => handleDeleteID(transaction.transaction_id, e)}
                                        >
                                            <i className="icon-trash"></i>
                                        </Button>
                                    </div>
                                </div>
                            ),
                        };
                    });

                    setOriginalData(transactionData);
                    setData(transactionData);
                } else {
                    console.error('Invalid data format received:', response.data);
                    Swal.fire('Error!', 'Invalid data format received', 'error');
                }
            } catch (error) {
                console.error('Error fetching transactions:', error);
                Swal.fire('Error!', 'Failed to fetch transaction data', 'error');
            }
        };

        fetchData();
    }, []);

    const handleDeleteID = async (transactionID, event) => {
        event.preventDefault();
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            customClass: {
                container: 'swal2-container'
            }
        });

        if (result.isConfirmed) {
            try {
                await _axios.delete(`${ServerPath}/transaction-history/${transactionID}`);
                setData(prevData => prevData.filter(data => data.transaction_id !== transactionID));
                setOriginalData(prevData => prevData.filter(data => data.transaction_id !== transactionID));
                Swal.fire('Deleted!', 'Transaction has been deleted.', 'success');
            } catch (error) {
                console.error('Error deleting transaction:', error);
                Swal.fire('Error!', 'There was an error deleting the transaction.', 'error');
            }
        }
    };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleMultiDelete = () => {
        if (window.confirm(`Are you sure you want to delete the selected items?`)) {
            setToggleDelete(!toggleDelete);
            const updatedData = data.filter((item) => !selectedRows.find(row => row.transaction_id === item.transaction_id));
            setData(updatedData);
            setOriginalData(updatedData);
            setSelectedRows([]);
        }
    };

    return (
        <Fragment>
            <style>{tableStyles}</style>
            <Row>
                <Col sm="12">
                    <Card>
                        <CardBody className='pt-0'>
                            {selectedRows.length > 0 && (
                                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                                    <h4 className="text-muted m-0">Delete Selected Records?</h4>
                                    <Btn attrBtn={{ color: 'danger', onClick: handleMultiDelete }}>Delete</Btn>
                                </div>
                            )}
                            <DataTable
                                className='data-tables theme-scrollbar pt-4'
                                data={data}
                                columns={tableColumns.map(col => ({
                                    ...col,
                                    selector: typeof col.selector === 'function'
                                        ? (row, index) => col.selector(row, index, currentPage, perPage)
                                        : col.selector,
                                    id: col.name === 'Payment Status' ? 'payment_status' : undefined,
                                }))}
                                fixedHeader
                                fixedHeaderScrollHeight="600px"
                                striped={true}
                                center={true}
                                pagination
                                paginationServer={false}
                                paginationTotalRows={data.length}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handlePerRowsChange}
                                selectableRows
                                onSelectedRowsChange={handleRowSelected}
                                clearSelectedRows={toggleDelete}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};

export default TransactionTable;